(function(window, angular) {
	'use strict';
	
	angular
		.module('animateOnChangeModule')
		.directive('animateOnChange', [
			'$timeout',
			animateOnChangeFunction
		]);

	function animateOnChangeFunction($timeout) {
		return {
			restrict: 'A',
			link: function($scope, $element, $attrs) {

				$scope.$watch($attrs.animateOnChange, function(newValue, oldValue) {
					if (newValue !== oldValue) {

						$element.addClass('changed');
						$timeout(function() {
							$element.removeClass('changed');
						}, 1000);
					}
				}, true);
			}
		};
	}
})(window, window.angular);